
export type GetAllUsers401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
